module.exports = __webpack_public_path__ + "970168c21329d1af6f9a9516ac3d3deb.svg";